/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import Chart from "chart.js";

export default {
  name: "ShellEdit",
  components: {
    Multiselect,
  },

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      id: null,
      reportId: "",
      originalReportId: "",
      programId: "",
      originalProgramId: "",
      // The stored SourceId when a document is scoped to a program
      originalSourceId: "",
      showLoading: false,
      isGraphGenerating: false,

      // Program-based statistics configurations
      LocationType: "datalake",
      location: "",
      reportType: "",
      columnFieldNames: [],
      groupByField: "",

      // Dynamic dropdown / datasets lists
      dbDatasets: [],
      interimVersions: [],
      interimVersionFiles: { ADAM_FIleName: [], Adam_FilePath: "" },
      selectedIntVersion: "",
      isEDC: false,
      categoricalFields: [],
      numericalFields: [],
      columnFilters: [],
      groupByFilter: [],
      columnFiltersValues: [],
      programData: null,
      studyInfo: {
        studyId: "",
        studyName: "",
        studyRef: ""
      },

      // Shell Details
      shellName: "",
      version: "",
      isDefault: false,
      createdAt: null,
      selectoption: "",

      // Validation
      shellNameError: "",

      // Font Settings
      fontFamily: "monospace",
      fontSize: null,

      // Page Layout
      orientation: "",
      widthMm: null,
      heightMm: null,
      marginTopMm: null,
      marginBottomMm: null,
      marginLeftMm: null,
      marginRightMm: null,

      // Title
      titleText: "",
      titleBold: true,
      titleAlign: "left",

      // Header
      headerBorderBottom: true,
      headerRows: [{ left: "", center: "", right: "" }],
      maxHeaderRows: 3,

      // Footer
      footerBorderTop: true,
      footerRows: [{ left: "", center: "", right: "" }],
      maxFooterRows: 3,

      // Token options from API
      tokenOptions: [],

      fontFamilyOptions: ["monospace", "Arial", "Times New Roman", "Courier New", "Helvetica"],
      chartInstance: null,



      // Table summary row
      tableSummary: { label: 'Number of Subjects with any TEAE', placebo: '22(73.33%)', bmsLow: '25(83.33%)', bmsHigh: '27(90.00%)', total: '74(82.22%)' },

      // Table data sections
      tableData: [
        {
          section: 'Gastrointestinal Disorders',
          rows: [
            { term: 'Nausea', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '7(23.33%)', total: '14(15.56%)' },
            { term: 'Vomiting', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '5(16.67%)', total: '10(11.11%)' },
            { term: 'Diarrhoea', placebo: '4(13.33%)', bmsLow: '5(16.67%)', bmsHigh: '6(20.00%)', total: '15(16.67%)' },
            { term: 'Abdominal Pain', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '7(7.78%)' },
            { term: 'Constipation', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '5(5.56%)' },
            { term: 'Dyspepsia', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '3(10.00%)', total: '5(5.56%)' }
          ]
        },
        {
          section: 'Nervous System Disorders',
          rows: [
            { term: 'Headache', placebo: '5(16.67%)', bmsLow: '6(20.00%)', bmsHigh: '8(26.67%)', total: '19(21.11%)' },
            { term: 'Dizziness', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '13(14.44%)' },
            { term: 'Somnolence', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '9(10.00%)' },
            { term: 'Tremor', placebo: '1(3.33%)', bmsLow: '2(6.67%)', bmsHigh: '3(10.00%)', total: '6(6.67%)' },
            { term: 'Paraesthesia', placebo: '0(0.00%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '3(3.33%)' }
          ]
        },
        {
          section: 'Skin and Subcutaneous Tissue Disorders',
          rows: [
            { term: 'Rash', placebo: '3(10.00%)', bmsLow: '4(13.33%)', bmsHigh: '5(16.67%)', total: '12(13.33%)' },
            { term: 'Pruritus', placebo: '2(6.67%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '9(10.00%)' },
            { term: 'Urticaria', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '4(4.44%)' },
            { term: 'Erythema', placebo: '0(0.00%)', bmsLow: '1(3.33%)', bmsHigh: '2(6.67%)', total: '3(3.33%)' }
          ]
        },
      
      ],

      // Listing summary row
      listSummary: { label: 'Number of Subjects with any TEAE', group: 'All', subjects: '74(82.22%)', events: '—', severity: '—' },

      // Listing data sections
      listData: [
        {
          section: 'Gastrointestinal Disorders',
          rows: [
            {
              term: 'Nausea',
              groups: [
                { group: 'Placebo', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '5', severity: 'Mild (3), Moderate (2)' },
                { group: 'BMS-High', subjects: '7(23.33%)', events: '9', severity: 'Mild (4), Moderate (3), Severe (2)' }
              ],
              total: { subjects: '14(15.56%)', events: '17' }
            },
            {
              term: 'Vomiting',
              groups: [
                { group: 'Placebo', subjects: '2(6.67%)', events: '2', severity: 'Mild (2)' },
                { group: 'BMS-Low', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '10(11.11%)', events: '11' }
            },
            {
              term: 'Diarrhoea',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '5(16.67%)', events: '4', severity: 'Mild (2), Moderate (2)' },
                { group: 'BMS-High', subjects: '6(20.00%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '15(16.67%)', events: '14' }
            },
            {
              term: 'Abdominal Pain',
              groups: [
                { group: 'Placebo', subjects: '2(6.67%)', events: '2', severity: 'Mild (2)' },
                { group: 'BMS-Low', subjects: '2(6.67%)', events: '2', severity: 'Mild (1), Moderate (1)' },
                { group: 'BMS-High', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' }
              ],
              total: { subjects: '7(7.78%)', events: '7' }
            }
          ]
        },
        {
          section: 'Nervous System Disorders',
          rows: [
            {
              term: 'Headache',
              groups: [
                { group: 'Placebo', subjects: '5(16.67%)', events: '5', severity: 'Mild (4), Moderate (1)' },
                { group: 'BMS-Low', subjects: '6(20.00%)', events: '7', severity: 'Mild (4), Moderate (3)' },
                { group: 'BMS-High', subjects: '8(26.67%)', events: '10', severity: 'Mild (5), Moderate (3), Severe (2)' }
              ],
              total: { subjects: '19(21.11%)', events: '22' }
            },
            {
              term: 'Dizziness',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '5', severity: 'Mild (3), Moderate (2)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '6', severity: 'Mild (3), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '13(14.44%)', events: '15' }
            }
          ]
        },
        {
          section: 'Skin and Subcutaneous Tissue Disorders',
          rows: [
            {
              term: 'Rash',
              groups: [
                { group: 'Placebo', subjects: '3(10.00%)', events: '3', severity: 'Mild (2), Moderate (1)' },
                { group: 'BMS-Low', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-High', subjects: '5(16.67%)', events: '5', severity: 'Mild (3), Moderate (2)' }
              ],
              total: { subjects: '12(13.33%)', events: '12' }
            }
          ]
        },
        {
          section: 'Infections and Infestations',
          rows: [
            {
              term: 'Nasopharyngitis',
              groups: [
                { group: 'Placebo', subjects: '4(13.33%)', events: '4', severity: 'Mild (3), Moderate (1)' },
                { group: 'BMS-Low', subjects: '5(16.67%)', events: '5', severity: 'Mild (4), Moderate (1)' },
                { group: 'BMS-High', subjects: '6(20.00%)', events: '7', severity: 'Mild (4), Moderate (2), Severe (1)' }
              ],
              total: { subjects: '15(16.67%)', events: '16' }
            }
          ]
        },
      ]

    };
  },

  computed: {
    tableHeaders() {
      // First column: Group By field
      const firstColLabel = this.groupByField || 'Body System / Preferred Term';
      const headers = [{ label: firstColLabel, align: 'left' }];

      headers.push(
        { label: 'Placebo', align: 'center' },
        { label: 'BMS-Low', align: 'center' },
        { label: 'BMS-High', align: 'center' },
        { label: 'Total', align: 'center' }
      );

      return headers;
    },
    computedTableData() {
      if (!this.columnFieldNames || this.columnFieldNames.length === 0) {
        return this.tableData;
      }

      const data = [];
      this.columnFieldNames.forEach(filter => {
        let rows = [];
        if (filter === 'AGE') {
          rows = [
            { term: '19', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '1(3.33%)', total: '3(3.33%)' },
            { term: '23', placebo: '1(3.33%)', bmsLow: '1(3.33%)', bmsHigh: '1(3.33%)', total: '3(3.33%)' },
            { term: '35', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '43', placebo: '5(16.67%)', bmsLow: '5(16.67%)', bmsHigh: '5(16.67%)', total: '15(16.67%)' },
            { term: '44', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '45', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '48', placebo: '6(20.00%)', bmsLow: '6(20.00%)', bmsHigh: '6(20.00%)', total: '18(20.00%)' },
            { term: '55', placebo: '7(23.33%)', bmsLow: '7(23.33%)', bmsHigh: '7(23.33%)', total: '21(23.33%)' },
            { term: '65', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '4(13.33%)', total: '12(13.33%)' }
          ];
        } else if (filter === 'AGEGR1' || filter === 'AGEGR1N') {
          rows = [
            { term: '>60', placebo: '4(13.33%)', bmsLow: '4(13.33%)', bmsHigh: '4(13.33%)', total: '12(13.33%)' },
            { term: '18-30', placebo: '2(6.67%)', bmsLow: '2(6.67%)', bmsHigh: '2(6.67%)', total: '6(6.67%)' },
            { term: '31-45', placebo: '11(36.67%)', bmsLow: '11(36.67%)', bmsHigh: '11(36.67%)', total: '33(36.67%)' },
            { term: '46-60', placebo: '13(43.33%)', bmsLow: '13(43.33%)', bmsHigh: '13(43.33%)', total: '39(43.33%)' }
          ];
        } else if (filter === 'SEX') {
          rows = [
            { term: 'Female', placebo: '15(50.00%)', bmsLow: '16(53.33%)', bmsHigh: '17(56.67%)', total: '48(53.33%)' },
            { term: 'Male', placebo: '15(50.00%)', bmsLow: '14(46.67%)', bmsHigh: '13(43.33%)', total: '42(46.67%)' }
          ];
        } else if (filter === 'RACE') {
          rows = [
            { term: 'White', placebo: '20(66.67%)', bmsLow: '20(66.67%)', bmsHigh: '20(66.67%)', total: '60(66.67%)' },
            { term: 'Black', placebo: '7(23.33%)', bmsLow: '7(23.33%)', bmsHigh: '6(20.00%)', total: '20(22.22%)' },
            { term: 'Asian', placebo: '3(10.00%)', bmsLow: '3(10.00%)', bmsHigh: '4(13.33%)', total: '10(11.11%)' }
          ];
        } else if (filter === 'AESEV') {
          rows = [
            { term: 'Mild', placebo: '12(40.00%)', bmsLow: '11(36.67%)', bmsHigh: '12(40.00%)', total: '35(38.89%)' },
            { term: 'Moderate', placebo: '13(43.33%)', bmsLow: '14(46.67%)', bmsHigh: '13(43.33%)', total: '40(44.44%)' },
            { term: 'Severe', placebo: '5(16.67%)', bmsLow: '5(16.67%)', bmsHigh: '5(16.67%)', total: '15(16.67%)' }
          ];
        } else {
          rows = [
            { term: 'Category A', placebo: '10(33.33%)', bmsLow: '12(40.00%)', bmsHigh: '15(50.00%)', total: '37(41.11%)' },
            { term: 'Category B', placebo: '20(66.67%)', bmsLow: '18(60.00%)', bmsHigh: '15(50.00%)', total: '53(58.89%)' }
          ];
        }
        data.push({ section: filter, rows });
      });
      return data;
    },
    listingHeaders() {
      const headers = [{ label: 'Body System / Preferred Term', class: 'col-term' }];
      if (!this.columnFieldNames || this.columnFieldNames.length === 0) {
        headers.push(
          { label: 'Treatment Group', class: 'col-group' },
          { label: 'Subjects n (%)', class: 'col-subjects' },
          { label: 'Events n', class: 'col-events' },
          { label: 'Severity', class: 'col-severity' }
        );
      } else {
        this.columnFieldNames.forEach((filter, index) => {
          let cls = 'col-group';
          if (index === this.columnFieldNames.length - 1) {
            cls = 'col-severity';
          }
          headers.push({ label: filter, class: cls });
        });
      }
      return headers;
    },
    selectedStudyId() {
      return store.getters.getStudyIs;
    },

    // Returns the correct image path based on dropdown selection
    // previewImage() {
    //   const images = {
    //     figure: require("../../assets/img/shellchart.png"),
    //     table: require("../../assets/img/shelltable.png"),
    //     listing: require("../../assets/img/shelllist.png"),
    //   };
    //   return images[this.selectoption] || require("../../assets/img/shellchart.png");
    // },
    titleTokenOptions() {
      return this.tokenOptions.filter(opt => opt.label === "Programme Title");
    },
    shellLevel() {
      if (this.id) {
        if (!this.showLoading) {
          if (this.originalSourceId) {
            return 'program';
          } else if (this.originalReportId) {
            return 'report';
          } else {
            return 'study';
          }
        }
      }
      if (this.programId) {
        return 'program';
      } else if (this.reportId) {
        return 'report';
      } else {
        return 'study';
      }
    }
  },

  watch: {
    selectedStudyId(newVal, oldVal) {
      if (oldVal && newVal && newVal !== oldVal) {
        this.$router.push("/shells");
      }
    },
    shellName(val) {
      if (val && val.trim()) {
        this.shellNameError = "";
      }
    },
    selectoption(newVal) {
      // Sync reportType when selectoption changes (program-level)
      const mapping = {
        'table': 'Table',
        'figure': 'Graph',
        'listing': 'Listing'
      };
      if (mapping[newVal] && this.programId) {
        this.reportType = mapping[newVal];
      }

      // Render or destroy chart based on selection
      if (newVal === 'figure') {
        this.isGraphGenerating = true;
        this.$nextTick(() => this.renderChart());
      } else {
        // Hide loader for table and listing views
        this.isGraphGenerating = false;
        if (this.chartInstance) {
          this.chartInstance.destroy();
          this.chartInstance = null;
        }
      }
    },
    footerRows: {
      deep: true,
      handler(rows) {
        const footnoteValue = this.tokenOptions.find(opt =>
          opt.label.toLowerCase().replace(/\s/g, '') === 'footnote'
        )?.value;

        if (!footnoteValue) return;

        rows.forEach(row => {
          if (row.left !== footnoteValue) return;
          // Clear center and right when left is footnote
          row.center = "";
          row.right = "";
        });
      }
    },
    columnFieldNames: {
      deep: true,
      handler() {
        if (this.selectoption === 'figure') {
          this.$nextTick(() => this.renderChart());
        }
      }
    },
  },

  async mounted() {
    this.id = this.$route.params.id;
    this.reportId = this.getRouteReportId();
    this.programId = this.getRouteProgramId();
    await this.fetchTokenOptions();
    if (this.id) {
      await this.getShellById();
    }
    if (this.programId) {
      await this.loadProgramStatsDetails();
    }
  //   if (this.selectoption === 'figure') {
  //     this.isGraphGenerating = true;
  //     this.$nextTick(() => this.renderChart());
  //   }
  //   else if (!this.selectoption) {
  //   this.selectoption = 'figure';
  //   this.isGraphGenerating = true;
  //   this.$nextTick(() => this.renderChart());
  // }
    if (!this.selectoption) {
      this.selectoption = 'figure';
      this.isGraphGenerating = true;
      this.$nextTick(() => this.renderChart());
      }
  },


  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },

  methods: {
    getCellValue(row, headerLabel) {
      if (!row) return '';
      const label = String(headerLabel).toLowerCase().replace(/\s/g, '');
      
      if (label === 'placebo' || label === 'female' || label === 'white' || label === 'mild' || label === 'age') {
        return row.placebo || '';
      }
      if (label === 'bms-low' || label === 'male' || label === 'black' || label === 'moderate' || label === '<65years' || label === 'agegr1' || label === 'agegr1n') {
        return row.bmsLow || '';
      }
      if (label === 'bms-high' || label === 'asian' || label === 'severe' || label === '>=65years') {
        return row.bmsHigh || '';
      }
      if (label === 'total') {
        return row.total || '';
      }
      
      return row.placebo || '0(0.00%)';
    },
    getRouteReportId() {
      const reportId = this.$route && this.$route.query
        ? this.$route.query.reportId
        : "";
      return Array.isArray(reportId) ? reportId[0] : reportId || "";
    },

    getRouteProgramId() {
      const programId = this.$route && this.$route.query
        ? this.$route.query.programId
        : "";
      return Array.isArray(programId) ? programId[0] : programId || "";
    },

    normalizeReportId(reportId) {
      if (
        reportId === null ||
        reportId === undefined ||
        String(reportId).trim().toLowerCase() === "null" ||
        String(reportId).trim().toLowerCase() === "undefined"
      ) {
        return "";
      }
      return reportId;
    },

    goToShells() {
      const query = {};
      if (this.reportId) query.reportId = this.reportId;
      if (this.programId) query.programId = this.programId;

      // Preserve origin (from) so the Shells page can decide navigation behavior
      const origin = this.$route && this.$route.query ? this.$route.query.from : null;
      if (origin) query.from = Array.isArray(origin) ? origin[0] : origin;

      this.$router.push({ path: "/shells", query: query });
    },

    // Normalize a stored DB value to the closest matching token value
    normalizeToken(val) {
      if (!val) return '';
      // 1. Exact match
      const exact = this.tokenOptions.find(opt => opt.value === val);
      if (exact) return exact.value;
      // 2. Partial match — find token whose value is contained in the stored string
      const partial = this.tokenOptions.find(opt => opt.value && val.includes(opt.value));
      if (partial) return partial.value;
      return val;
    },

    getTokenLabel(value) {
      if (!value) return '';
      // 1. Exact match
      const exact = this.tokenOptions.find(opt => opt.value === value);
      if (exact) return exact.label;
      // 2. Partial match — stored value contains a token value
      const partial = this.tokenOptions.find(opt => opt.value && value.includes(opt.value));
      if (partial) return partial.label;
      // 3. Fallback — strip {{ }} for display
      return value.replace(/\{\{|\}\}/g, '').replace(/\s*\|\s*/g, ' | ').trim();
    },

    async fetchTokenOptions() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/tokens`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.tokenOptions = res.data.tokens || [];
      } catch (err) {
        console.error("[ShellEdit] Failed to fetch token options:", err);
        this.tokenOptions = [];
      }
    },

    async getShellById() {
      const idtoken = store.getters.getIdToken;
      this.showLoading = true;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/shellconfig/${this.id}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        const data = res.data.data || res.data;
        this.originalReportId = this.normalizeReportId(data.ReportId || data.Reportid || data.reportId);
        this.reportId = this.originalReportId || this.normalizeReportId(this.reportId);
        this.originalProgramId = this.normalizeReportId(data.ProgramId || data.Programid || data.programId);
        // SourceId is the canonical field used for program-level scoping in the API
        this.originalSourceId = this.normalizeReportId(data.SourceId || data.Sourceid || data.sourceId || "");
        this.programId = this.originalProgramId || this.normalizeReportId(this.programId) || this.originalSourceId || this.programId;

        this.shellName = data.TemplateName || "";
        this.version = data.Version || "";
        this.isDefault = data.IsDefault || data.Isdefault || data.isDefault || false;
        this.createdAt = data.CreatedAt || null;

        const font = data.Font || {};
        this.fontFamily = font.family || "monospace";
        this.fontSize = font.sizePt || 10;

        const pl = data.PageLayout || {};
        this.orientation = pl.orientation || "";
        this.widthMm = pl.widthMm || 0;
        this.heightMm = pl.heightMm || 0;
        this.marginTopMm = pl.marginTopMm !== undefined ? pl.marginTopMm : 0;
        this.marginBottomMm = pl.marginBottomMm !== undefined ? pl.marginBottomMm : 0;
        this.marginLeftMm = pl.marginLeftMm !== undefined ? pl.marginLeftMm : 0;
        this.marginRightMm = pl.marginRightMm !== undefined ? pl.marginRightMm : 0;

        const title = data.Title || {};
        const lines = Array.isArray(title.lines) ? title.lines : [];
        this.titleText = lines.join(", ");
        this.titleBold = title.bold !== undefined ? title.bold : true;
        this.titleAlign = title.align || "left";

        const header = data.Header || {};
        this.headerBorderBottom = header.borderBottom !== undefined ? header.borderBottom : true;
        this.headerRows = (header.rows && header.rows.length > 0)
          ? header.rows.map(r => ({
            left: this.normalizeToken(r.left),
            center: this.normalizeToken(r.center),
            right: this.normalizeToken(r.right)
          }))
          : [{ left: "", center: "", right: "" }];

        const footer = data.Footer || {};
        this.footerBorderTop = footer.borderTop !== undefined ? footer.borderTop : true;
        this.footerRows = (footer.rows && footer.rows.length > 0)
          ? footer.rows.map(r => ({
            left: this.normalizeToken(r.left),
            center: this.normalizeToken(r.center),
            right: this.normalizeToken(r.right)
          }))
          : [{ left: "", center: "", right: "" }];

        // Load Column Filters from shell config
        this.columnFieldNames = data.ColumnFilters || [];
        this.groupByField = data.GroupBy || "";

      } catch (err) {
        console.error("Get shell error:", err);
        alert("Failed to load shell data.");
      } finally {
        this.showLoading = false;
      }
    },

    // Create a new shell at the given level ('program' or 'report')
    async createNewShell(level) {
      if (!this.validate()) return;

      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      const payload = {
        StudyId: studyId,
        // For program-level overrides the API expects `SourceId` to be populated
        ReportId: level === 'report' ? (this.reportId || null) : null,
        SourceId: level === 'program' ? (this.programId || null) : null,
        TemplateName: this.shellName,
        Version: this.version,
        // When creating a scoped override it should become the default for that scope
        IsDefault: true,
        CreatedAt: this.createdAt,
        Font: { family: this.fontFamily, sizePt: Number(this.fontSize) },
        PageLayout: {
          orientation: this.orientation,
          widthMm: Number(this.widthMm),
          heightMm: Number(this.heightMm),
          marginTopMm: Number(this.marginTopMm),
          marginBottomMm: Number(this.marginBottomMm),
          marginLeftMm: Number(this.marginLeftMm),
          marginRightMm: Number(this.marginRightMm),
        },
        Title: {
          lines: this.titleText ? [this.titleText] : [],
          bold: this.titleBold,
          align: this.titleAlign,
        },
        Header: {
          borderBottom: this.headerBorderBottom,
          rows: this.headerRows.map((r, i) => ({ rowIndex: i, left: r.left || "", center: r.center || "", right: r.right || "" })),
        },
        Footer: {
          borderTop: this.footerBorderTop,
          rows: this.footerRows.map((r, i) => ({ rowIndex: i, left: r.left || "", center: r.center || "", right: r.right || "" })),
        },
        ProgramName: this.programData ? this.programData.ProgramName || "" : "",
        ColumnFilters: this.columnFieldNames || [],
        GroupBy: this.reportType === 'Table' ? this.groupByField : ""
      };

      try {
        this.showLoading = true;
        const headers = { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" };
        if (!idtoken) {
          console.error('[ShellEdit] Missing id token for POST /shellconfig');
          alert('Authentication token missing. Please login again.');
          return;
        }

        try {
          const duplicateCheckUrl = this.programId
            ? `${this.baseurl}/stats-python/shellconfig/program-list/${studyId}/${this.programId}`
            : this.reportId
              ? `${this.baseurl}/stats-python/shellconfig/report-list/${studyId}/${this.reportId}`
              : `${this.baseurl}/stats-python/shellconfig/study/${studyId}`;

          console.debug('[ShellEdit] Duplicate check URL:', duplicateCheckUrl);
          const checkRes = await axios.get(duplicateCheckUrl, { headers });
          const duplicateData = checkRes.data && checkRes.data.data !== undefined
            ? checkRes.data.data
            : checkRes.data;
          let existingShells = Array.isArray(duplicateData)
            ? duplicateData
            : duplicateData && duplicateData._id
              ? [duplicateData]
              : [];

          if (this.programId) {
            existingShells = existingShells.filter(s => {
              const pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
              return pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
            });
          } else if (this.reportId) {
            existingShells = existingShells.filter(s => {
              const rid = s.ReportId || s.Reportid || s.reportId || "";
              const pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
              const hasReport = rid && String(rid).trim().toLowerCase() !== "null" && String(rid).trim().toLowerCase() !== "undefined";
              const hasProgram = pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
              return hasReport && !hasProgram;
            });
          } else {
            existingShells = existingShells.filter(s => {
              const rid = s.ReportId || s.Reportid || s.reportId || "";
              const pid = s.ProgramId || s.Programid || s.ProgramID || s.programId || s.programid || s.program_id || s.ProgrammeId || s.programmeId || s.SourceId || s.Sourceid || s.sourceId || s.sourceid || "";
              const hasReport = rid && String(rid).trim().toLowerCase() !== "null" && String(rid).trim().toLowerCase() !== "undefined";
              const hasProgram = pid && String(pid).trim().toLowerCase() !== "null" && String(pid).trim().toLowerCase() !== "undefined";
              return !hasReport && !hasProgram;
            });
          }

          const enteredVersion = this.version.trim().toLowerCase();
          const versionMatch = existingShells.find(s =>
            s.Version && s.Version.trim().toLowerCase() === enteredVersion
          );
          if (versionMatch) {
            alert(`Version "${this.version}" already exists. Please use a different version.`);
            return;
          }
        } catch (err) {
          console.warn("[ShellEdit] Could not fetch shell list for duplicate check:", err);
        }

        const url = `${this.baseurl}/stats-python/shellconfig/`;
        console.debug('[ShellEdit] POST URL:', url);
        console.debug('[ShellEdit] POST payload:', payload);

        try {
          const res = await axios.post(url, payload, { headers });
          console.debug('[ShellEdit] POST response:', res && res.status, res && res.data);
          alert("Shell created successfully");
          this.goToShells();
        } catch (err) {
          console.error("Create shell error:", err);
          console.error('Create shell error - response status:', err.response?.status);
          console.error('Create shell error - response data:', err.response?.data);
          console.error('Create shell error - response headers:', err.response?.headers);

          // Retry with alternate slash style if 404 (some servers require it)
          if (err.response?.status === 404) {
            const retryUrl = url.endsWith('/') ? url.slice(0, -1) : url + '/';
            console.debug('[ShellEdit] Retrying POST with trailing slash:', retryUrl);
            try {
              const retryRes = await axios.post(retryUrl, payload, { headers });
              console.debug('[ShellEdit] Retry POST response:', retryRes && retryRes.status, retryRes && retryRes.data);
              alert("Shell created successfully (retry)");
              this.goToShells();
              return;
            } catch (retryErr) {
              console.error('[ShellEdit] Retry POST error:', retryErr);
              console.error('Retry response status:', retryErr.response?.status);
              console.error('Retry response data:', retryErr.response?.data);
              const retryMsg = retryErr.response?.data?.messages?.[0] || retryErr.response?.data?.message || retryErr.message || 'Retry failed.';
              alert(retryMsg);
              return;
            }
          }

          if (err.response?.data?.detail) {
            const detailMsg = typeof err.response.data.detail === 'string'
              ? err.response.data.detail
              : JSON.stringify(err.response.data.detail, null, 2);
            alert("Validation Error:\n" + detailMsg);
          } else {
            const msg = err.response?.data?.messages?.[0] || err.response?.data?.message || err.message || "Failed to create shell.";
            alert(msg);
          }
        }
      } finally {
        this.showLoading = false;
      }
    },

    async saveAsNewProgram() {
      await this.createNewShell('program');
    },

    async saveAsNewReport() {
      await this.createNewShell('report');
    },
    isFootnoteSelected(row) {
      const footnoteValue = this.tokenOptions.find(opt =>
        opt.label.toLowerCase().replace(/\s/g, '') === 'footnote')?.value;
      return row.left === footnoteValue;
    },
    handleFooterSelection(row, position) {
      const footnoteValue = this.tokenOptions.find(opt =>
        opt.label.toLowerCase().replace(/\s/g, '') === 'footnote'
      )?.value;

      if (!footnoteValue) return;

      // ❗ If user selects Footnote in center or right
      if (row[position] === footnoteValue) {
        if (row.left !== footnoteValue) {
          alert("Please fill footnote in left");

          // Reset the selected value
          row[position] = "";
        }
      }
    },
    validate() {
      this.shellNameError = "";
      if (!this.shellName || !this.shellName.trim()) {
        this.shellNameError = "Please fill the shell name.";
        return false;
      }
      return true;
    },

    async updateShell() {
      if (!this.validate()) return;

      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      let reportIdPayload = null;
      let sourceIdPayload = null;
      const currentLevel = this.shellLevel;

      if (currentLevel === 'program') {
        sourceIdPayload = this.normalizeReportId(this.originalSourceId || this.programId) || null;
      } else if (currentLevel === 'report') {
        reportIdPayload = this.normalizeReportId(this.originalReportId || this.reportId) || null;
      }
      // study level: both remain null — no scoping IDs sent

      console.debug('[ShellEdit] updateShell - shellLevel:', currentLevel,
        '| reportIdPayload:', reportIdPayload,
        '| sourceIdPayload:', sourceIdPayload);

      // Build payload with only the scoping ID relevant to this shell's level
      const payload = {
        StudyId: studyId,
        TemplateName: this.shellName,
        Version: this.version,
        IsDefault: this.isDefault,
        CreatedAt: this.createdAt,
        Font: { family: this.fontFamily, sizePt: Number(this.fontSize) },
        PageLayout: {
          orientation: this.orientation,
          widthMm: Number(this.widthMm),
          heightMm: Number(this.heightMm),
          marginTopMm: Number(this.marginTopMm),
          marginBottomMm: Number(this.marginBottomMm),
          marginLeftMm: Number(this.marginLeftMm),
          marginRightMm: Number(this.marginRightMm),
        },
        Title: {
          lines: this.titleText ? [this.titleText] : [],
          bold: this.titleBold,
          align: this.titleAlign,
        },
        Header: {
          borderBottom: this.headerBorderBottom,
          rows: this.headerRows.map((r, i) => ({ rowIndex: i, left: r.left || "", center: r.center || "", right: r.right || "" })),
        },
        Footer: {
          borderTop: this.footerBorderTop,
          rows: this.footerRows.map((r, i) => ({ rowIndex: i, left: r.left || "", center: r.center || "", right: r.right || "" })),
        },
        ProgramName: this.programData ? this.programData.ProgramName || "" : "",
        ColumnFilters: this.columnFieldNames || [],
        GroupBy: this.reportType === 'Table' ? this.groupByField : ""
      };

      // Only attach the scoping ID for the correct level
      // Study level  → StudyId only (no ReportId, no SourceId)
      // Report level → StudyId + ReportId only
      // Program level → StudyId + SourceId only
      if (currentLevel === 'report') {
        payload.ReportId = reportIdPayload;
      } else if (currentLevel === 'program') {
        payload.SourceId = sourceIdPayload;
      }

      try {
        this.showLoading = true;
        const headers = { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" };

        const saveRes = await axios.put(
          `${this.baseurl}/stats-python/shellconfig/${this.id}`,
          payload,
          { headers }
        );
        const savedData = saveRes && saveRes.data
          ? saveRes.data.data || saveRes.data
          : {};
        this.reportId = this.normalizeReportId(
          savedData.ReportId || savedData.Reportid || savedData.reportId || this.reportId
        );
        // If the saved document returned a SourceId (program-level) capture it, otherwise fallback to ProgramId
        this.programId = this.normalizeReportId(
          savedData.SourceId || savedData.Sourceid || savedData.sourceId || savedData.ProgramId || savedData.programId || this.programId
        );
        alert("Shell updated successfully");
        this.goToShells();
      } catch (err) {
        console.error("Update shell error:", err.response?.data || err);
        if (err.response?.data?.detail) {
          alert("Validation Error:\n" + JSON.stringify(err.response.data.detail, null, 2));
        } else {
          const msg = err.response?.data?.messages?.[0] || err.response?.data?.message || "Failed to update shell.";
          alert(msg);
        }
      } finally {
        this.showLoading = false;
      }
    },

    addHeaderRow() {
      if (this.headerRows.length < this.maxHeaderRows) this.headerRows.push({ left: "", center: "", right: "" });
    },
    removeHeaderRow() {
      if (this.headerRows.length > 1) this.headerRows.pop();
    },
    addFooterRow() {
      if (this.footerRows.length < this.maxFooterRows) this.footerRows.push({ left: "", center: "", right: "" });
    },
    removeFooterRow() {
      if (this.footerRows.length > 1) this.footerRows.pop();
    },
    async loadProgramStatsDetails() {
      if (!this.programId) return;

      const idtoken = store.getters.getIdToken;
      const studyId = store.getters.getStudyIs;

      try {
        this.showLoading = true;
        const res = await axios.get(
          `${this.baseurl}/stats-python/programme/getprogrambyid/${this.programId}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        const data = res.data;
        this.programData = data;

        this.studyInfo.studyId = data.StudyId || studyId;
        this.studyInfo.studyName = data.StudyName || "";
        this.studyInfo.studyRef = data.StudyRef || "";

        this.LocationType = data.LocationType || "datalake";
        this.location = data.Location || "";
        this.selectedIntVersion = data.ProgramVersion || "";
        this.isEDC = !!data.ProgramVersion;
        this.reportType = data.ReportType || "";
        // Only load column filters and group by from program if not already set from shell config
        if (!this.columnFieldNames || this.columnFieldNames.length === 0) {
          this.columnFieldNames = data.ColumnFilters || [];
        }
        if (!this.groupByField) {
          this.groupByField = data.GroupBy || "";
        }

        // Synchronize starting selectoption with reportType
        const reverseMapping = {
          'Table': 'table',
          'Graph': 'figure',
          'Listing': 'listing'
        };
        if (reverseMapping[this.reportType]) {
          this.selectoption = reverseMapping[this.reportType];
        }

        if (this.LocationType === "database") {
          await this.listDbDatasets();
        } else {
          await this.listInterimVersions();
          await this.listInterimVersionFiles();
        }
        await this.listFieldNames();

      } catch (err) {
        console.error("[ShellEdit] Failed to load program statistics details:", err);
      } finally {
        this.showLoading = false;
      }
    },

    async listDbDatasets() {
      if (!this.studyInfo.studyId) return;
      const idtoken = store.getters.getIdToken;
      const version = this.selectedIntVersion || "V1.0";
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/getversioneddatasetsdb?studyid=${this.studyInfo.studyId}&datasetversion=${version}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.dbDatasets = res.data || [];
      } catch (err) {
        console.error("[ShellEdit] Failed to list database datasets:", err);
      }
    },

    async listInterimVersions() {
      if (!this.studyInfo.studyId) return;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/getadamdatalakeinterimversions?StudyId=${this.studyInfo.studyId}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.interimVersions = res.data || [];
      } catch (err) {
        console.error("[ShellEdit] Failed to list interim versions:", err);
      }
    },

    async listInterimVersionFiles() {
      if (!this.studyInfo.studyId) return;
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/getversionfiles?StudyId=${this.studyInfo.studyId}&interimversion=${this.selectedIntVersion}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.interimVersionFiles = res.data[0] || { ADAM_FIleName: [], Adam_FilePath: "" };
      } catch (err) {
        console.error("[ShellEdit] Failed to list interim version files:", err);
      }
    },

    async listFieldNames() {
      if (!this.studyInfo.studyId || !this.location) return;
      const idtoken = store.getters.getIdToken;
      let parameter = "";
      if (this.LocationType === "database") {
        const fileName = this.location.split("-");
        parameter = `studyId=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${fileName[0]}&threshold=10&interimver=${fileName[1] || ''}`;
      } else if (this.LocationType === "datalake") {
        parameter = `studyId=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${this.location}&threshold=10&interimver=${this.selectedIntVersion}`;
      }

      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/fields2?${parameter}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        const cat = res.data.categorical || [];
        const num = res.data.numerical || [];

        this.categoricalFields = cat;
        this.numericalFields = num;

        this.columnFilters = [...cat, ...num].sort((a, b) => a.localeCompare(b));
        this.groupByFilter = [...cat].sort((a, b) => a.localeCompare(b));
        this.columnFiltersValues = this.columnFilters.map(field => ({ label: field, value: field }));
      } catch (err) {
        console.error("[ShellEdit] Failed to list field names:", err);
      }
    },

    async locationChanged() {
      await this.listFieldNames();
    },

    reportTypeChanged() {
      const mapping = {
        'Table': 'table',
        'Graph': 'figure',
        'Listing': 'listing'
      };
      if (mapping[this.reportType]) {
        this.selectoption = mapping[this.reportType];
      }
    },

    shellpageclose() {
      const from = this.$route && this.$route.query ? this.$route.query.from : null;
      if (from === "tocgenerate") {
        this.$router.push({ path: "/tocgenerate" });
        return;
      }

      if (from === "shells") {
        this.$router.push({ path: "/shells", query: { reportId: this.reportId, programId: this.programId } });
        return;
      }

      // Default: go back one step in history
      if (this.$router && typeof this.$router.go === "function") {
        this.$router.go(-1);
      } else {
        this.$router.push({ path: "/shells" });
      }
    },
    renderChart() {
  const ctx = this.$refs.teaeChart?.getContext('2d');
  if (!ctx) {
    setTimeout(() => {
      if (this.selectoption === 'figure') {
        this.renderChart();
      }
    }, 100);
    return; // Don't touch isGraphGenerating here, caller already set it
  }

  if (this.chartInstance) {
    this.chartInstance.destroy();
    this.chartInstance = null;
  }

  // isGraphGenerating is already true — set by caller, don't set again here

  const datasets = [];
  const colors = [
    { bg: 'rgba(240, 128, 128, 0.85)', border: 'rgba(240, 128, 128, 1)' },
    { bg: 'rgba(50, 210, 80, 0.90)', border: 'rgba(50, 210, 80, 1)' },
    { bg: 'rgba(100, 160, 240, 0.85)', border: 'rgba(100, 160, 240, 1)' },
    { bg: 'rgba(255, 206, 86, 0.85)', border: 'rgba(255, 206, 86, 1)' },
    { bg: 'rgba(153, 102, 255, 0.85)', border: 'rgba(153, 102, 255, 1)' },
  ];

  const groups = [];
  if (!this.columnFieldNames || this.columnFieldNames.length === 0) {
    groups.push({ label: 'TRTA' });
  } else {
    this.columnFieldNames.forEach(filter => {
      groups.push({ label: filter });
    });
  }

  const dummyDataSets = [
    [22, 18, 9],
    [27, 25, 14],
    [12, 11, 9],
    [15, 13, 8],
    [8, 7, 5],
  ];

  groups.forEach((grp, idx) => {
    const color = colors[idx % colors.length];
    const dataVal = dummyDataSets[idx % dummyDataSets.length];
    datasets.push({
      label: grp.label,
      data: dataVal,
      backgroundColor: color.bg,
      borderColor: color.border,
      borderWidth: 1,
    });
  });

  // Single setTimeout, no double isGraphGenerating set
  setTimeout(() => {
    const currentCtx = this.$refs.teaeChart?.getContext('2d');
    if (!currentCtx) {
      this.isGraphGenerating = false;
      return;
    }

    let animationCompleted = false;

    this.chartInstance = new Chart(currentCtx, {
      type: 'bar',
      data: {
        labels: ['Gastrointestinal\nDisorders', 'Nervous System\nDisorders', 'Skin & Subcutaneous\nDisorders'],
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 300,
          onComplete: () => {
            animationCompleted = true;
            this.isGraphGenerating = false; // hide loader once
          }
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            fontColor: '#cccccc',
            fontSize: 10,
            fontFamily: 'monospace',
            boxWidth: 12,
            padding: 12,
          }
        },
        tooltips: {
          mode: 'single',
          intersect: true,
          backgroundColor: '#2a2a2a',
          titleFontColor: '#ffffff',
          bodyFontColor: '#cccccc',
          borderColor: '#444',
          borderWidth: 1,
        },
        scales: {
          xAxes: [{
            ticks: { fontColor: '#aaaaaa', fontSize: 9, fontFamily: 'monospace' },
            gridLines: { color: 'rgba(255,255,255,0.07)' }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Subjects',
              fontColor: '#aaaaaa',
              fontSize: 10,
              fontFamily: 'monospace',
            },
            ticks: {
              fontColor: '#aaaaaa',
              fontSize: 9,
              fontFamily: 'monospace',
              stepSize: 5,
              beginAtZero: true,
              max: 30,
            },
            gridLines: { color: 'rgba(255,255,255,0.1)' }
          }]
        }
      }
    });

    // Single fallback — only fires if animation callback never ran
    setTimeout(() => {
      if (!animationCompleted) {
        this.isGraphGenerating = false;
      }
    }, 500);

  }, 100);
    },

  },
};
